module.exports = __webpack_public_path__ + "static/media/trekking.2c8c9bf6.svg";